module.exports = __webpack_public_path__ + "static/a-mind-for-numbers-048fea0189dbae9ed8a43049e8a8dd2c.jpg";